import { render, staticRenderFns } from "./flowGoodsDrawer.vue?vue&type=template&id=3e58f4ef&scoped=true"
import script from "./flowGoodsDrawer.vue?vue&type=script&lang=js"
export * from "./flowGoodsDrawer.vue?vue&type=script&lang=js"
import style0 from "./flowGoodsDrawer.vue?vue&type=style&index=0&id=3e58f4ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e58f4ef",
  null
  
)

export default component.exports